import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useSite } from '@/context/SiteContext';

export const WhatsAppButton = () => {
  const { siteData } = useSite();
  
  const whatsappLink = siteData?.contact?.whatsappLink || 'https://wa.me/351967472503';

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#20BA5C] transition-all duration-300 hover:scale-110 animate-bounce-subtle"
      aria-label="Contactar via WhatsApp"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  );
};
